import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {RecordsStateType, Signal} from "../models"

// Selectors
import {selectCurrentRecordSignalsList, selectSignalFetching} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    signals: selectCurrentRecordSignalsList(state),
    signalsFetching: selectSignalFetching(state),
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, null)(BaseComponent)

export type WithRecordSignalsProps = {
    signals: Array<Signal>
    signalsFetching: RecordsStateType["fetchingSignals"]
}
